import { AfterViewInit, Component, Input } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import * as feather from 'feather-icons';
import { Competency } from 'src/app/common/models/competency';

@Component({
    selector: 'app-review',
    templateUrl: './review.component.html',
    styleUrls: ['./review.component.css'],
    standalone: false
})
export class ReviewComponent implements AfterViewInit {

  @Input() competencies: Competency[];
  @Input() stepper: MatStepper;

  ngAfterViewInit() {
    feather.replace();
  }
}
